import Footer from "../components/footer/Footer";
import "../components/cart/Cart.css"
import Navbar from "../components/navbar/Navbar";
import Banner from "../components/banner/Banner";
import MyAccount from "../components/profile/MyAccount";
import ProfileSideBar from "../components/profile/ProfileSideBar"; 
import MyAddress from "../components/profile/MyAddresses";
import { useEffect } from "react";
const Addresses=()=>{
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
    
    return(
<div className="bg-imagea">
<Navbar/>
<Banner title="My Account"/>

<div className="bg-imagea">
                <section className="ftco-section contact-section">
                    <div className="container mt-5 text-left">
                        <div className="row block-9">
                            <div className="col-md-3 contact-info ">
                                <ProfileSideBar />
                            </div>
                            <div className="col-md-1"></div>
                            <div className="col-md-8 ">
                              <MyAddress/>
                            </div>
                        </div>
                    </div>
                </section>

            </div>




<Footer/>
</div>
    )
}
export default Addresses;